import type { ProductResponse } from "../productsApi";
import { Button } from "@mui/material";
import { ProductMapDialog } from "./ProductMapDialog";
import type { FC } from "react";

interface DialogProps {
  readonly open: boolean;
  readonly availableProducts?: ProductResponse[];
  readonly onClose: () => void;
  readonly onAddProduct?: (product: ProductResponse, date?: string) => void;
  readonly date?: string;
}

export const AddProductFromMapDialog: FC<DialogProps> = ({ availableProducts, open, onAddProduct, onClose }) => (
  <ProductMapDialog products={availableProducts} open={open} onClose={onClose}>
    <AddProductButton onClick={onAddProduct} />
  </ProductMapDialog>
);

interface ButtonProps {
  readonly product?: ProductResponse;
  readonly date?: string;
  readonly onClick?: (product: ProductResponse, date?: string) => void;
}

export const AddProductButton: FC<ButtonProps> = ({ onClick, product, date }) => (
  <Button onClick={() => onClick?.(product!, date)}>Dodaj produkt</Button>
);
